import React from "react";
import thaiImg from "./thai-dry-massage.jpg";   // ⭐ IMAGE IMPORT FIXED

const ThaiDryMassage = ({ setActiveSection }) => {
  return (
    <section className="bg-white text-gray-900">

      {/* ⭐ FULL PREMIUM BANNER —  STYLE */}
      <div className="relative w-full h-[350px] md:h-[450px]">

        {/* Background Image */}
        <img
          src={thaiImg}
          alt="Thai Dry Massage Banner"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/50"></div>

        {/* ⭐ CENTER MAIN TITLE */}
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white drop-shadow-lg">
            Thai Dry Massage
          </h1>
        </div>

        {/* ⭐ LEFT BOTTOM TITLE */}
        <div className="absolute bottom-0 left-0 bg-black/40 w-full py-4 px-6">
          <h2 className="text-xl md:text-2xl font-semibold text-white">
            Thai Dry Massage
          </h2>
        </div>

        {/* ⭐ RIGHT BOTTOM BREADCRUMB */}
        <div className="absolute bottom-0 right-0 bg-black/40 py-4 px-6 flex gap-2 text-white">
          <button
            onClick={() => setActiveSection("home")}
            className="hover:text-amber-300 transition"
          >
            Home
          </button>
          <span>›</span>
          <span className="text-amber-300">Thai Dry Massage</span>
        </div>
      </div>

      {/* ⭐ MAIN CONTENT — TRIKAAYA STYLE */}
      <div className="container mx-auto px-4 py-20 grid md:grid-cols-2 gap-12 items-center">

        {/* LEFT IMAGE */}
        <div>
          <img
            src={thaiImg}
            alt="Thai Dry Massage Treatment"
            className="rounded-2xl shadow-2xl w-full h-[500px] object-cover"
          />
        </div>

        {/* RIGHT DESCRIPTION */}
        <div>
          <h2 className="text-4xl md:text-5xl font-bold mb-8 text-amber-900 leading-tight">
            Traditional Healing Through Stretch & Pressure Therapy
          </h2>

          <p className="text-gray-700 leading-relaxed mb-5 text-lg">
            Thai Dry Massage is one of the oldest healing treatments in
            traditional Thai therapy, combining acupressure, stretching,
            rhythmic pressure, and yogic techniques to release tension and
            increase body flexibility.
          </p>

          <p className="text-gray-700 leading-relaxed mb-5 text-lg">
            The therapist uses hands, elbows, knees, and thumbs to apply
            pressure on energy lines, helping remove blockages and restore
            natural energy flow throughout the body.
          </p>

          <p className="text-gray-700 leading-relaxed mb-5 text-lg">
            This massage is ideal for people with back pain, stiffness, or those
            who prefer non-oil therapy. It offers deep muscle relaxation and
            increases mobility.
          </p>

          <p className="text-gray-700 leading-relaxed mb-5 text-lg">
            Experience authentic Thai healing that rejuvenates your body,
            improves strength, and restores balance.
          </p>

          {/* BOOK NOW BUTTON */}
          <button
            onClick={() => setActiveSection("booking")}
            className="bg-amber-900 text-white px-12 py-4 rounded-lg text-lg 
                       hover:bg-amber-800 transition-all hover:scale-105 shadow-xl"
          >
            Book Now
          </button>
        </div>
      </div>

    </section>
  );
};

export default ThaiDryMassage;
